/**
 * ================================================================
 * Bisou Rivage — bisou-mockup.js
 * ================================================================
 * Bouton « En savoir plus » dans la rangée d'achat (#bisou-mockup-btn).
 * Desktop : à droite de l'ATC (25% → 50% au survol). Clic → panneau
 *           in-flow entre l'achat et « Associez le » ; image sticky.
 * Mobile  : bouton plein → ouvre une « sheet » grise arrondie (− pour
 *           fermer) listant les fiches ; tap fiche → carte « Tinder »
 *           (glisse : côtés = volet suivant/préc, haut/bas = ferme).
 * ================================================================
 */
(function () {
  'use strict';

  /* Pont i18n : les libellés viennent de sections/bisou-mockup.liquid, le JS n'a pas
     accès au filtre | t. Chaque appel garde son repli français. */
  var I18N = {};
  try { I18N = JSON.parse((document.getElementById('bisou-mockup-i18n') || {}).textContent || '{}'); } catch (e) {}
  function t(key, fallback) {
    var v = I18N[key];
    return (typeof v === 'string' && v) ? v : fallback;
  }
  function tfill(key, fallback, vars) {
    var s = t(key, fallback);
    for (var k in vars) {
      if (Object.prototype.hasOwnProperty.call(vars, k)) s = s.split('{' + k + '}').join(vars[k]);
    }
    return s;
  }

  var A_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h16M14 6l6 6-6 6"/></svg>';
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"/></svg>';

  function init() {
    var section = document.querySelector('.bisou-mockup-section');
    var anchor = document.getElementById('bisou-mockup-btn');
    var mount = document.getElementById('bisou-mockup-mount');
    if (!section || !anchor || !mount || anchor.dataset.built) return;
    var srcs = Array.prototype.slice.call(section.querySelectorAll('.bm-src'));
    if (!srcs.length) return;
    anchor.dataset.built = '1';

    var num = function (s) { return s.getAttribute('data-num'); };
    var title = function (s) { return s.getAttribute('data-title'); };
    var media = function (s) { return s.querySelector('.bm-src-media'); };
    var body = function (s) { return s.querySelector('.bm-src-body'); };

    var mq = window.matchMedia('(min-width: 900px)');
    var mode = null;

    /* ═══════════ DIMENSIONS ADAPTATIVES ═══════════
       Le volet « Dimensions » (corps contenant un <table> A4/A3/A2) est transformé :
       faux-cadre orienté (H/V selon le produit) + couleurs distinctes par élément,
       et tableau réduit au SEUL format choisi par le client + lien « voir plus ». */
    var DIM_COLORS = { 'Cadre': '#2f2a24', 'Papier': '#9a948a', 'Image': '#6e8aa6', 'Ouv. PP': '#b8985e' };
    var DIM_ORDER = ['Cadre', 'Papier', 'Ouv. PP', 'Image'];
    var DIM_LABEL = { 'Cadre': 'Cadre', 'Papier': 'Papier', 'Ouv. PP': 'Passe-partout', 'Image': 'Image' };
    var dimData = null;

    function parseDimPair(s) { if (!s) return null; var m = String(s).match(/(\d+)\D+(\d+)/); return m ? [+m[1], +m[2]] : null; }

    function parseDimTable(table) {
      var head = table.querySelectorAll('thead th, thead td');
      var fmts = [];
      for (var i = 1; i < head.length; i++) fmts.push(head[i].textContent.trim().toUpperCase());
      var data = {};
      Array.prototype.forEach.call(table.querySelectorAll('tbody tr'), function (tr) {
        var cells = tr.querySelectorAll('td, th'); if (cells.length < 2) return;
        var measure = cells[0].textContent.trim();
        for (var j = 1; j < cells.length; j++) { var f = fmts[j - 1]; if (!f) continue; (data[f] || (data[f] = {}))[measure] = cells[j].textContent.trim(); }
      });
      return Object.keys(data).length ? data : null;
    }

    function productOrient() { var a = document.getElementById('rv5-bloc-associated'); return (a && a.dataset.orientation) === 'horizontal' ? 'horizontal' : 'vertical'; }
    function selectedFmt() { var r = document.querySelector('.rv5-format-row.active'); var f = r && (r.getAttribute('data-f') || '').toUpperCase(); return (f === 'A2' || f === 'A3' || f === 'A4') ? f : null; }

    /* Couleur du cadre selon la finition choisie (lit le libellé couleur de la fiche). */
    function frameColor() {
      var el = document.getElementById('rv5-color-label');
      /* Meme piege que le chronometre de resize : une variable « t » ici
         masquerait le helper i18n t() pour toute la fonction. */
      var label = (el ? el.textContent : '').toLowerCase();
      if (/noir|black/.test(label)) return '#2b2724';
      if (/blanc|white/.test(label)) return '#d6d2ca';
      if (/ch.?ne|oak/.test(label)) return '#b8895a';
      if (/bouleau|birch/.test(label)) return '#d8c39c';
      if (/sans|none|papier|paper/.test(label)) return '#cfcabe';
      return '#2f2a24';
    }

    /* Schéma annoté : CADRE CENTRÉ, chaque élément étiqueté par une ligne de rappel fine
       + pastille colorée. Pointillés aérés. La couleur du cadre suit la finition choisie. */
    function dimSvg(dRaw, orient) {
      function P(k, fb) { var p = parseDimPair(dRaw && dRaw[k]); p = p || fb; return orient === 'horizontal' ? [p[1], p[0]] : p; }
      var cad = P('Cadre', [500, 700]);
      var pap = P('Papier', [Math.round(cad[0] * 0.84), Math.round(cad[1] * 0.85)]);
      var ouv = P('Ouv. PP', [Math.round(cad[0] * 0.78), Math.round(cad[1] * 0.83)]);
      var img = P('Image', [Math.round(cad[0] * 0.74), Math.round(cad[1] * 0.8)]);
      var fw = cad[0], fh = cad[1];
      var pad = 20, side = Math.max(220, Math.round(fw * 0.52));
      var vbW = side + fw + side, vbH = pad + fh + pad;
      var cx = vbW / 2, cy = vbH / 2;           // ← cadre centré
      var fcol = frameColor();
      function rect(d, fill, stroke, sw, dash) { var x = (cx - d[0] / 2).toFixed(1), y = (cy - d[1] / 2).toFixed(1); return '<rect x="' + x + '" y="' + y + '" width="' + d[0] + '" height="' + d[1] + '" rx="4" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + sw + '"' + (dash ? ' stroke-dasharray="' + dash + '"' : '') + '/>'; }
      var s = '<svg class="bm-dimsvg" viewBox="0 0 ' + Math.round(vbW) + ' ' + Math.round(vbH) + '" role="img" aria-label="' + t('anatomy_aria', 'Anatomie du tirage encadré') + '">';
      s += rect(cad, '#f4efe6', fcol, 14);
      s += rect(pap, '#ffffff', '#9a948a', 2, '18 13');
      s += rect(ouv, 'none', '#b8985e', 2.5);
      s += rect(img, '#cfdae4', '#6e8aa6', 2.5);
      var labelX = cx + cad[0] / 2 + 24;
      var items = [['Cadre', cad[0], fcol], ['Papier', pap[0], DIM_COLORS['Papier']], ['Ouv. PP', ouv[0], DIM_COLORS['Ouv. PP']], ['Image', img[0], DIM_COLORS['Image']]];
      var rows = [0.15, 0.38, 0.62, 0.85];
      items.forEach(function (it, i) {
        var col = it[2], ry = cy - fh / 2 + fh * rows[i], sx = cx + it[1] / 2;
        s += '<line x1="' + sx.toFixed(1) + '" y1="' + ry.toFixed(1) + '" x2="' + (labelX - 9) + '" y2="' + ry.toFixed(1) + '" stroke="#d3ccbe" stroke-width="1.3"/>';
        s += '<circle cx="' + sx.toFixed(1) + '" cy="' + ry.toFixed(1) + '" r="4.5" fill="' + col + '"/>';
        s += '<text x="' + labelX + '" y="' + (ry + 9).toFixed(1) + '" font-family="Space Mono, monospace" font-size="29" fill="' + col + '">' + DIM_LABEL[it[0]] + '</text>';
      });
      s += '</svg>';
      return s;
    }

    function dimFmtButtons(active) {
      if (!dimData) return '';
      var html = '<div class="bm-dimfmts">';
      ['A4', 'A3', 'A2'].forEach(function (f) { if (!dimData[f]) return; html += '<button type="button" class="bm-dimfmt' + (f === active ? ' on' : '') + '" data-f="' + f + '">' + f + '</button>'; });
      return html + '</div>';
    }

    function dimTable(fmt, dRaw) {
      var html = '<table class="bm-dimtable"><tbody><tr class="bm-dimtable-h"><td colspan="2">Format ' + fmt + '</td></tr>';
      DIM_ORDER.forEach(function (k) {
        var v = dRaw && dRaw[k]; if (!v) return;
        if (!/mm/i.test(v)) v += ' mm';
        var col = (k === 'Cadre') ? frameColor() : DIM_COLORS[k];
        html += '<tr><td><span class="bm-dimdot" style="background:' + col + '"></span><span style="color:' + col + '">' + DIM_LABEL[k] + '</span></td><td>' + v + '</td></tr>';
      });
      html += '</tbody></table>';
      return html;
    }

    function renderDimPanel(media, body) {
      var fmt = (body && body.getAttribute('data-dim-fmt')) || selectedFmt() || 'A2';
      var orient = productOrient();
      var dRaw = dimData && dimData[fmt];
      if (media) media.innerHTML = '<div class="bm-dimcap">' + tfill('anatomy_caption_html', 'Anatomie d\'un tirage encadré — exemple {fmt}', { fmt: fmt }) + '</div>' + dimSvg(dRaw, orient);
      if (body) {
        var intro = body.getAttribute('data-dim-intro') || '';
        body.innerHTML = intro + dimTable(fmt, dRaw) + '<a class="bm-dimmore" href="/pages/formats-dimensions">' + t('see_all_formats', 'Voir tous les formats →') + '</a>';
      }
    }

    function enhanceDims(scope) {
      if (!scope || !scope.querySelectorAll) return;
      Array.prototype.forEach.call(scope.querySelectorAll('.bm-src-body'), function (body) {
        if (body.dataset.dimDone) return;
        var table = body.querySelector('table'); if (!table) return;
        if (!dimData) dimData = parseDimTable(table);
        if (!dimData) return;
        body.dataset.dimDone = '1';
        var intro = body.querySelector('p'); body.setAttribute('data-dim-intro', intro ? intro.outerHTML : '');
        var media = body.parentNode && body.parentNode.querySelector('.bm-src-media');
        if (media) media.classList.add('bm-dim-media');
        body.classList.add('bm-dim-body');
        renderDimPanel(media, body);
      });
    }

    function refreshDims() {
      Array.prototype.forEach.call(document.querySelectorAll('.bm-dim-body'), function (body) {
        body.removeAttribute('data-dim-fmt');
        renderDimPanel(body.parentNode && body.parentNode.querySelector('.bm-dim-media'), body);
      });
    }
    document.addEventListener('bisou:variant-change', refreshDims);
    /* clic sur un bouton format dans un panneau dimensions → aperçu local (sans toucher au panier) */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.bm-dimfmt');
      if (!b) return;
      var body = b.closest('.bm-dim-body'); if (!body) return;
      body.setAttribute('data-dim-fmt', b.getAttribute('data-f'));
      renderDimPanel(body.parentNode && body.parentNode.querySelector('.bm-dim-media'), body);
    });

    /* Desktop only: one short wheel gesture advances exactly one product block.
       Targets are based on stable block wrappers; inner content can finish
       rendering without changing the order or making a block unreachable. */
    function installDesktopMagneticScroll() {
      try {
        if (new URLSearchParams(window.location.search).get('product_scroll') === 'free') {
          document.documentElement.classList.add('bisou-product-scroll-free');
        }
      } catch (e) {}
      if (document.documentElement.classList.contains('bisou-product-scroll-free')) return;
      if (window.__bisouProductMagneticScroll) return;
      window.__bisouProductMagneticScroll = true;

      /* ── Machine d'état simple ──
         Zone SLIDES (blocs 1-2-3 plein écran) : la molette est entièrement
         contrôlée, un geste = un bloc. Zone LIBRE (sous le bloc 3) : scroll
         naturel ; en remontant, le premier geste RECALE fermement le bloc 3
         (preventDefault + verrou 500ms), le geste suivant monte au bloc 2. */
      var acc = 0;
      var accDir = 0;
      var accTimer = null;
      var locked = false;
      var lockTimer = null;
      var animating = false;
      var animationId = 0;
      var dotsRoot = null;

      function lock(ms) {
        locked = true;
        clearTimeout(lockTimer);
        lockTimer = setTimeout(function () { locked = false; acc = 0; }, ms);
      }

      function absoluteTop(el) {
        var rect = el.getBoundingClientRect();
        return window.scrollY + rect.top;
      }

      function slides() {
        var first = document.querySelector('.bisou-s1-wrapper');
        var second = document.getElementById('bisou-mockup-mount');
        var third = document.getElementById('rv5-bloc-associated');
        var thirdGrid = third && third.querySelector('.rv5-associated-grid');
        if (!first || !second || !third) return [];
        if (!first.offsetParent || !second.offsetParent || !third.offsetParent) return [];
        if (second.getBoundingClientRect().height < 20 || third.getBoundingClientRect().height < 20) return [];

        var vh = window.innerHeight;
        function centerY(el) {
          var h = el.getBoundingClientRect().height;
          return Math.max(0, Math.round(absoluteTop(el) + h / 2 - vh / 2));
        }
        /* Bloc 3 : le haut des vignettes se cale sur le haut de l'image principale
           — meme ligne d'horizon d'une colonne a l'autre (Max, 19/08 : elles
           « flottent plus bas/haut selon la hauteur du bloc info »).

           La colonne image est sticky (top:0, height:100vh) : une fois passe le
           premier ecran, sa position DANS LE VIEWPORT ne bouge plus. On peut
           donc lire le haut du cadre a n'importe quel moment et s'en servir de
           cible : apres le scroll, head doit se trouver a cette meme hauteur,
           donc scrollY = absoluteTop(head) - hautDuCadre.

           Sans cadre mesurable (mobile, colonne non sticky, image pas encore
           chargee), on retombe sur l'ancien centrage sur le contenu reel. */
        function contentCenterY(section) {
          var head = section.querySelector('.rv5-associated-header');
          var tail = section.querySelector('.bmx-atc3row') || thirdGrid;
          if (!head || !tail) return centerY(section);

          var frame = document.querySelector('.rv5-media-frame');
          if (frame) {
            var frameRect = frame.getBoundingClientRect();
            if (frameRect.height > 20) {
              return Math.max(0, Math.round(absoluteTop(head) - frameRect.top));
            }
          }

          var top = absoluteTop(head);
          var bot = absoluteTop(tail) + tail.getBoundingClientRect().height;
          return Math.max(0, Math.round((top + bot) / 2 - vh / 2));
        }
        return [
          { el: first, y: centerY(first) },
          { el: second, y: centerY(second) },
          { el: third, visualEl: thirdGrid || third, y: contentCenterY(third) }
        ];
      }

      /* Si le document ne descend pas assez pour permettre le centrage du bloc 3
         (grands écrans : il « s'écrasait » en bas de page), on ajoute juste ce
         qu'il faut d'espace scrollable après le bloc. */
      var roomSpacer = null;
      function ensureCenteringRoom(list) {
        var vh = window.innerHeight;
        var currentSpacer = roomSpacer ? roomSpacer.offsetHeight : 0;
        var maxScroll = Math.max(0, document.documentElement.scrollHeight - vh - currentSpacer);
        var lack = Math.round(list[2].y - maxScroll);
        if (lack > 0) {
          if (!roomSpacer) {
            roomSpacer = document.createElement('div');
            roomSpacer.className = 'bmx-room-spacer';
            roomSpacer.setAttribute('aria-hidden', 'true');
            /* APRÈS le bloc 3 (jamais dedans : sa hauteur sert au centrage) */
            var host = document.getElementById('rv5-bloc-associated');
            if (host && host.parentNode) {
              host.parentNode.insertBefore(roomSpacer, host.nextSibling);
            } else {
              document.body.appendChild(roomSpacer);
            }
          }
          roomSpacer.style.height = Math.min(lack, Math.round(vh * 0.45)) + 'px';
        } else if (roomSpacer && currentSpacer > 0) {
          roomSpacer.style.height = '0px';
        }
      }

      function visualBottom(slide) {
        var el = slide.visualEl || slide.el;
        return absoluteTop(el) + el.getBoundingClientRect().height;
      }

      function ensureDots(list) {
        if (dotsRoot || list.length !== 3) return;
        dotsRoot = document.createElement('nav');
        dotsRoot.className = 'bmx-slide-dots';
        dotsRoot.setAttribute('aria-label', 'Navigation de la fiche produit');
        list.forEach(function (_, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bmx-slide-dot';
          dot.setAttribute('aria-label', 'Afficher le bloc ' + (index + 1));
          dot.addEventListener('click', function () {
            var currentList = slides();
            if (!currentList[index]) return;
            lock(550);
            animateTo(currentList[index].y);
          });
          dotsRoot.appendChild(dot);
        });
        document.body.appendChild(dotsRoot);
      }

      function updateDots(list) {
        ensureDots(list);
        ensureCenteringRoom(list);
        if (!dotsRoot) return;
        var current = window.scrollY;
        var thirdBottom = absoluteTop(list[2].el) + list[2].el.getBoundingClientRect().height;
        var inProductSlides = current >= list[0].y - 60 && current <= thirdBottom;
        dotsRoot.classList.toggle('is-visible', inProductSlides);
        dotsRoot.setAttribute('aria-hidden', inProductSlides ? 'false' : 'true');
        var active = 0;
        var distance = Infinity;
        list.forEach(function (slide, index) {
          var d = Math.abs(slide.y - current);
          if (d < distance) { distance = d; active = index; }
        });
        Array.prototype.forEach.call(dotsRoot.children, function (dot, index) {
          dot.classList.toggle('is-active', index === active);
          dot.setAttribute('aria-current', index === active ? 'step' : 'false');
        });
      }

      function canScrollInside(target, direction) {
        var node = target && target.nodeType === 1 ? target : null;
        while (node && node !== document.body) {
          var style = getComputedStyle(node);
          var overflow = style.overflowY;
          var scrollable = (overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight + 2;
          if (scrollable) {
            if (direction > 0 && node.scrollTop < node.scrollHeight - node.clientHeight - 2) return true;
            if (direction < 0 && node.scrollTop > 2) return true;
          }
          node = node.parentElement;
        }
        return false;
      }

      function animateTo(targetY) {
        animationId += 1;
        var id = animationId;
        var from = window.scrollY;
        var distance = targetY - from;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var duration = reduceMotion ? 0 : Math.min(560, Math.max(380, Math.abs(distance) * 0.4));
        var started = performance.now();
        animating = true;

        function frame(now) {
          if (id !== animationId) return;
          var progress = duration ? Math.min(1, (now - started) / duration) : 1;
          var eased = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
          window.scrollTo(0, from + distance * eased);
          if (progress < 1) {
            requestAnimationFrame(frame);
          } else {
            animating = false;
          }
        }
        requestAnimationFrame(frame);
      }

      window.__bisouAnimateTo = animateTo;

      window.addEventListener('wheel', function (event) {
        if (!mq.matches || event.ctrlKey || document.documentElement.classList.contains('bisou-product-scroll-free')) return;

        var direction = event.deltaY > 0 ? 1 : event.deltaY < 0 ? -1 : 0;
        if (!direction || canScrollInside(event.target, direction)) return;

        var list = slides();
        if (list.length !== 3) return;
        updateDots(list);

        var current = window.scrollY;
        var vh = window.innerHeight;
        var first = list[0].y;
        var last = list[2].y;

        /* ── ZONE LIBRE : sous le bloc 3 (artiste, avis, footer…) ── */
        if (current > last + 60) {
          if (direction < 0) {
            if (locked || animating) { event.preventDefault(); return; }
            if (current < visualBottom(list[2]) + vh * 0.35) {
              /* Le bloc 3 redevient visible : on le recale fermement.
                 Le verrou absorbe l'inertie, le geste SUIVANT ira au bloc 2. */
              event.preventDefault();
              lock(500);
              animateTo(last);
            }
          }
          return; /* scroll naturel */
        }

        /* ── ZONE SLIDES (blocs 1-2-3) ── */
        if (direction > 0 && current >= last - 14) return;   /* bloc 3 → bas : on libère */
        if (direction < 0 && current <= first + 14) return;  /* bloc 1 → haut : on libère */

        event.preventDefault();
        if (locked || animating) return;

        if (accDir !== direction) { acc = 0; accDir = direction; }
        acc += Math.abs(event.deltaY) * (event.deltaMode === 1 ? 16 : 1);
        clearTimeout(accTimer);
        accTimer = setTimeout(function () { acc = 0; }, 160);
        if (acc < 50) return;
        acc = 0;

        var active = 0;
        var nearest = Infinity;
        list.forEach(function (slide, index) {
          var distance = Math.abs(slide.y - current);
          if (distance < nearest) {
            nearest = distance;
            active = index;
          }
        });
        var destinationIndex = active + direction;
        if (destinationIndex < 0 || destinationIndex >= list.length) return;

        lock(550);
        animateTo(list[destinationIndex].y);
      }, { passive: false });

      window.addEventListener('scroll', function () {
        if (!mq.matches) return;
        var list = slides();
        if (list.length !== 3) return;
        updateDots(list);
      }, { passive: true });

      mq.addEventListener('change', function () {
        if (!mq.matches) {
          if (dotsRoot) dotsRoot.classList.remove('is-visible');
        }
      });

      setTimeout(function () {
        var list = slides();
        if (list.length === 3) {
          updateDots(list);
        }
      }, 350);
    }

    function wireCarousels(scope) {
      scope.querySelectorAll('.bm-media--carousel').forEach(function (m) {
        if (m.dataset.wired) return; m.dataset.wired = '1';
        var sl = m.querySelectorAll('.bm-slide'), dt = m.querySelectorAll('.bm-dot'), i = 0;
        function go(n) { i = (n + sl.length) % sl.length; sl.forEach(function (s, k) { s.classList.toggle('on', k === i); }); dt.forEach(function (d, k) { d.classList.toggle('on', k === i); }); }
        m.querySelectorAll('.bm-arr').forEach(function (a) { a.addEventListener('click', function (e) { e.stopPropagation(); go(i + parseInt(a.getAttribute('data-dir'), 10)); }); });
        dt.forEach(function (d) { d.addEventListener('click', function (e) { e.stopPropagation(); go(parseInt(d.getAttribute('data-k'), 10)); }); });
        sl.forEach(function (s, k) { s.classList.toggle('on', k === 0); }); dt.forEach(function (d, k) { d.classList.toggle('on', k === 0); });
      });
      scope.querySelectorAll('.bm-media:not(.bm-media--carousel) .bm-slide').forEach(function (s) { s.classList.add('on'); });
    }

    function rowsInto(list) {
      srcs.forEach(function (s) {
        var rrow = document.createElement('div'); rrow.className = 'bmx-row';
        rrow.innerHTML = '<div class="bmx-rh"><span class="bmx-rwrap"><span class="bmx-num">' + num(s) + '</span><span class="bmx-rt">' + title(s) + '</span></span><span class="bmx-pm" aria-hidden="true"></span></div><div class="bmx-rp"><div class="bmx-rin"></div></div>';
        var rin = rrow.querySelector('.bmx-rin');
        if (media(s)) rin.appendChild(media(s).cloneNode(true));
        if (body(s)) rin.appendChild(body(s).cloneNode(true));
        rrow.querySelector('.bmx-rh').addEventListener('click', function () {
          var w = rrow.classList.contains('open');
          list.querySelectorAll('.bmx-row').forEach(function (r) { r.classList.remove('open'); });
          if (!w) { rrow.classList.add('open'); wireCarousels(rin); }
        });
        list.appendChild(rrow);
      });
      enhanceDims(list);
    }

    /* ═══════════ DESKTOP — bloc 2 toujours ouvert, folder façon dossier Mac ═══════════ */
    function buildDesktop() {
      var artistSrc = section.querySelector('.bm-artist-src');
      var tirageSrc = section.querySelector('.bm-tirage-src');

      var panel = document.createElement('div'); panel.className = 'bmx-panel is-open';
      var cardEl = document.createElement('div'); cardEl.className = 'bmx-pcard';

      /* onglets dossier (marque-pages en haut à gauche) */
      var tabsWrap = document.createElement('div'); tabsWrap.className = 'bmx-tabs';
      var labels = [t('tab_cartel', 'Cartel'), t('tab_artist', 'Artiste'), t('tab_details', 'Détails')];
      var tabs = [];
      labels.forEach(function (l) {
        var tb = document.createElement('button'); tb.type = 'button'; tb.className = 'bmx-tab'; tb.textContent = l;
        tabsWrap.appendChild(tb); tabs.push(tb);
      });

      /* corps du dossier */
      var fbody = document.createElement('div'); fbody.className = 'bmx-fbody';

      var pInfos = document.createElement('div'); pInfos.className = 'bmx-pane bmx-pane--pad';
      pInfos.innerHTML = tirageSrc ? tirageSrc.innerHTML : '';

      var pArtist = document.createElement('div'); pArtist.className = 'bmx-pane bmx-pane--pad';
      pArtist.innerHTML = artistSrc ? artistSrc.innerHTML : '';

      var pDetails = document.createElement('div'); pDetails.className = 'bmx-pane';
      var list = document.createElement('div'); list.className = 'bmx-plist';
      rowsInto(list);
      var foot = document.createElement('div'); foot.className = 'bmx-pfoot';
      foot.innerHTML = '<span>Delivered in 14 business days</span><span>Printed and framed locally in France</span>';
      pDetails.appendChild(list); pDetails.appendChild(foot);

      fbody.appendChild(pInfos); fbody.appendChild(pArtist); fbody.appendChild(pDetails);
      cardEl.appendChild(tabsWrap); cardEl.appendChild(fbody);

      /* ATC sous le folder : [bouton] [détail au présent] [retour options] en ligne */
      var atcRow = document.createElement('div'); atcRow.className = 'bmx-atc2row';
      var atc2 = document.createElement('button'); atc2.type = 'button'; atc2.className = 'bmx-atc2';
      atc2.innerHTML = '<span class="bmx-atc2-l">Ajouter au panier</span>';
      atc2.addEventListener('click', function () { var real = document.querySelector('.product-form__submit'); if (real) real.click(); });
      var scrollToOptions = function () { var w = document.querySelector('.bisou-s1-wrapper'); if (w) w.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
      var detail = document.createElement('div'); detail.className = 'bmx-atc2info';
      /* l'étiquette info est cliquable : même action que la flèche (revenir aux options) */
      detail.setAttribute('role', 'button'); detail.setAttribute('tabindex', '0'); detail.setAttribute('aria-label', 'Revenir aux options');
      detail.addEventListener('click', scrollToOptions);
      detail.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToOptions(); } });
      var upBtn = document.createElement('button'); upBtn.type = 'button'; upBtn.className = 'bmx-up'; upBtn.setAttribute('aria-label', 'Revenir aux options');
      upBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V4M6 10l6-6 6 6"/></svg>';
      upBtn.addEventListener('click', scrollToOptions);
      atcRow.appendChild(atc2); atcRow.appendChild(detail); atcRow.appendChild(upBtn);
      cardEl.appendChild(atcRow);

      panel.appendChild(cardEl); mount.appendChild(panel);

      var panes = [pInfos, pArtist, pDetails];
      function sel(i) {
        tabs.forEach(function (tab, k) { tab.classList.toggle('on', k === i); });
        panes.forEach(function (p, k) { p.classList.toggle('on', k === i); });
      }
      tabs.forEach(function (tab, i) { tab.addEventListener('click', function () { sel(i); }); });
      sel(2); /* défaut : Détails (les volets) */

      /* Lien « + d'infos » du Bloc 1 → scroll vers Bloc 2 + ouvre l'onglet Cartel */
      setTimeout(function () {
        document.querySelectorAll('.rv5-more-link').forEach(function (link) {
          if (link.dataset.wiredMore) return;
          link.dataset.wiredMore = '1';
          link.addEventListener('click', function (e) {
            e.preventDefault();
            sel(0);
            if (window.__bisouAnimateTo) {
              var rect = mount.getBoundingClientRect();
              var y = window.scrollY + rect.top + rect.height / 2 - window.innerHeight / 2;
              window.__bisouAnimateTo(Math.max(0, Math.round(y)));
            }
          });
        });
      }, 0);

      /* cartel Infos : mise à jour live selon le format/cadre choisi */
      function updateCartel() {
        var fmtRow = document.querySelector('.rv5-format-row.active');
        var fmt = fmtRow ? (fmtRow.getAttribute('data-f') || '') : '';
        var colEl = document.getElementById('rv5-color-label');
        var col = colEl ? colEl.textContent.trim() : '';
        var stockEl = document.getElementById('rv5-stock-text');
        var fEl = pInfos.querySelector('[data-ct="format"]');
        var sEl = pInfos.querySelector('[data-ct="stock"]');
        if (fEl && fmt) {
          var gram = (fmt.toUpperCase() === 'A4') ? '300 g/m²' : '260 g/m²';
          fEl.textContent = fmt + (col ? ' · ' + col : '') + ' · ' + gram;
        }
        if (sEl && stockEl) {
          var m = stockEl.textContent.match(/(\d+)\s*\/\s*(\d+)/);
          if (m) sEl.textContent = 'Reste ' + m[1] + ' / ' + m[2] + ' dans ce format';
        }
        var priceEl = document.querySelector('.bisou-atc-price');
        var price = priceEl ? priceEl.textContent.trim() : '';
        var parts = [fmt, col, price].filter(function (x) { return x; });
        detail.textContent = parts.length ? parts.join(' · ') : '';
      }
      setTimeout(updateCartel, 200);
      document.addEventListener('bisou:variant-change', updateCartel);

      buildBloc3Atc();
      document.documentElement.classList.add('bmx-slides');
    }

    /* Bloc 3 (« Associez le ») : bouton « Combinez-le sur votre mur » (blanc / texte +
       contour noir) à gauche + flèche retour options à droite. Au clic, ouvre le wall
       planner en DIPTYQUE = produit principal (la page courante) + UNE carte « Associez le »
       VISIBLE à ce moment (la plus centrée dans le carrousel). Desktop uniquement. */
    function buildBloc3Atc() {
      var assoc = document.getElementById('rv5-bloc-associated');
      if (!assoc || assoc.dataset.atcBuilt) return;
      assoc.dataset.atcBuilt = '1';

      var wallHref = '/pages/framed-wall-planner';
      var oldCta = assoc.querySelector('.rv5-wall-cta');
      if (oldCta) {
        var oldLink = oldCta.querySelector('.rv5-wall-btn');
        if (oldLink && oldLink.getAttribute('href')) wallHref = oldLink.getAttribute('href');
        oldCta.style.display = 'none';
      }
      var planBase = wallHref.split('?')[0] || '/pages/framed-wall-planner';

      function handleFromUrl(u) { if (!u) return ''; var m = String(u).match(/\/products\/([^/?#]+)/); return m ? m[1].toLowerCase() : ''; }

      /* la carte associée la plus centrée dans la zone visible du carrousel */
      function pickVisibleAssoc() {
        var grid = assoc.querySelector('.rv5-associated-grid');
        if (!grid) return null;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.rv5-assoc-card'));
        if (!cards.length) return null;
        var gr = grid.getBoundingClientRect();
        var mid = gr.left + gr.width / 2;
        var best = null, bestDist = Infinity;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect();
          if (r.right < gr.left + 4 || r.left > gr.right - 4) return; /* hors zone visible */
          var d = Math.abs((r.left + r.width / 2) - mid);
          if (d < bestDist) { bestDist = d; best = c; }
        });
        return best || cards[0];
      }

      /* le bouton ET la flèche envoient tous deux vers le composer (diptyque) */
      function goToPlanner(e) {
        if (e) e.preventDefault();
        var ids = [];
        var mainH = handleFromUrl(assoc.dataset.productUrl) || handleFromUrl(window.location.pathname);
        if (mainH) ids.push(mainH);
        var card = pickVisibleAssoc();
        var assocH = card && handleFromUrl(card.getAttribute('href'));
        if (assocH && ids.indexOf(assocH) < 0) ids.push(assocH);
        window.location.href = planBase + (ids.length ? '?ids=' + ids.join(',') : '');
      }

      var row = document.createElement('div'); row.className = 'bmx-atc3row';
      var wall = document.createElement('a'); wall.className = 'bmx-wall3'; wall.href = planBase; wall.textContent = 'Combinez-le sur votre mur';
      wall.addEventListener('click', goToPlanner);
      var go = document.createElement('button'); go.type = 'button'; go.className = 'bmx-up'; go.setAttribute('aria-label', 'Combiner sur votre mur');
      go.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>';
      go.addEventListener('click', goToPlanner);
      row.appendChild(wall); row.appendChild(go);

      if (oldCta && oldCta.parentNode) { oldCta.parentNode.insertBefore(row, oldCta); }
      else { assoc.appendChild(row); }
    }

    /* ═══════════ MOBILE ═══════════ */
    function buildMobile() {
      var mLabel = section.getAttribute('data-mbtn-label') || t('more_info_btn', 'En savoir plus');
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'bmx-btn bmx-btn--full';
      btn.innerHTML = '<span class="bmx-pulse" aria-hidden="true"></span><span class="bmx-btn-long">' + mLabel + '</span><span class="bmx-plus" aria-hidden="true">+</span>';
      anchor.appendChild(btn);

      /* le bouton est REMPLACÉ par un bloc (fond = couleur du bouton) avec les fiches */
      var box = document.createElement('div'); box.className = 'bmx-mblock is-hidden';
      var bhead = document.createElement('div'); bhead.className = 'bmx-mblock-h';
      bhead.innerHTML = '<span class="bmx-mblock-t">' + mLabel + '</span>';
      var minus = document.createElement('button'); minus.type = 'button'; minus.className = 'bmx-mblock-x'; minus.setAttribute('aria-label', 'Fermer'); minus.innerHTML = MINUS;
      bhead.appendChild(minus); box.appendChild(bhead);
      srcs.forEach(function (s, i) {
        var card = document.createElement('button'); card.type = 'button'; card.className = 'bmx-card';
        card.innerHTML = '<span class="bmx-cno">' + num(s) + '</span><span class="bmx-ct">' + title(s) + '</span><span class="bmx-ca">' + A_R + '</span>';
        card.addEventListener('click', function () { openTinder(i); });
        box.appendChild(card);
      });
      anchor.appendChild(box);
      btn.addEventListener('click', function () { btn.classList.add('is-hidden'); box.classList.remove('is-hidden'); });
      minus.addEventListener('click', function () { box.classList.add('is-hidden'); btn.classList.remove('is-hidden'); });

      /* carte Tinder */
      var tin = document.createElement('div'); tin.className = 'bmx-tin'; tin.setAttribute('hidden', '');
      var tcard = document.createElement('div'); tcard.className = 'bmx-tcard';
      tcard.innerHTML = '<div class="bmx-thead"><span class="bmx-tno"></span><button type="button" class="bmx-txt" aria-label="Fermer">' + X + '</button></div><div class="bmx-tstage"></div><div class="bmx-tdots"></div>';
      tin.appendChild(tcard); document.body.appendChild(tin);
      var tno = tcard.querySelector('.bmx-tno'), stage = tcard.querySelector('.bmx-tstage'), dots = tcard.querySelector('.bmx-tdots');
      srcs.forEach(function () { var d = document.createElement('span'); d.className = 'bmx-td'; dots.appendChild(d); });
      var idx = 0;

      function render() {
        var s = srcs[idx];
        tno.innerHTML = '<span class="n">' + num(s) + '</span>' + title(s);
        stage.innerHTML = '';
        if (media(s)) stage.appendChild(media(s).cloneNode(true));
        if (body(s)) stage.appendChild(body(s).cloneNode(true));
        stage.scrollTop = 0;
        wireCarousels(stage);
        enhanceDims(stage);
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === idx); });
        tcard.style.transform = ''; tcard.style.opacity = '1';
      }
      function go(n) { idx = (n + srcs.length) % srcs.length; render(); }
      function openTinder(i) { idx = i; render(); tin.removeAttribute('hidden'); requestAnimationFrame(function () { tin.classList.add('is-open'); }); }
      function closeTinder() { tin.classList.remove('is-open'); setTimeout(function () { tin.setAttribute('hidden', ''); }, 220); }
      tcard.querySelector('.bmx-txt').addEventListener('click', closeTinder);
      tin.addEventListener('click', function (e) { if (e.target === tin) closeTinder(); });
      Array.prototype.forEach.call(dots.children, function (d, k) { d.addEventListener('click', function () { go(k); }); });

      /* drag (effet adouci) */
      var sx = 0, sy = 0, dx = 0, dy = 0, dragging = false;
      function down(e) { if (e.target.closest('.bmx-txt') || e.target.closest('.bm-arr') || e.target.closest('.bm-dot')) return; dragging = true; tcard.classList.add('drag'); var p = e.touches ? e.touches[0] : e; sx = p.clientX; sy = p.clientY; }
      function mv(e) { if (!dragging) return; var p = e.touches ? e.touches[0] : e; dx = p.clientX - sx; dy = p.clientY - sy; tcard.style.transform = 'translate(' + dx + 'px,' + dy + 'px) rotate(' + (dx * 0.025) + 'deg)'; }
      function up() {
        if (!dragging) return; dragging = false; tcard.classList.remove('drag');
        if (Math.abs(dy) > 95 && Math.abs(dy) > Math.abs(dx)) { tcard.style.transform = 'translateY(' + (dy > 0 ? 1 : -1) * 420 + 'px)'; tcard.style.opacity = '0'; setTimeout(closeTinder, 150); return; }
        if (Math.abs(dx) > 80) { tcard.style.transform = 'translateX(' + (dx > 0 ? 1 : -1) * 420 + 'px) rotate(' + (dx > 0 ? 9 : -9) + 'deg)'; tcard.style.opacity = '0'; setTimeout(function () { go(idx + (dx > 0 ? -1 : 1)); }, 140); return; }
        tcard.style.transform = '';
      }
      tcard.addEventListener('mousedown', down); window.addEventListener('mousemove', mv); window.addEventListener('mouseup', up);
      tcard.addEventListener('touchstart', down, { passive: true }); tcard.addEventListener('touchmove', mv, { passive: true }); tcard.addEventListener('touchend', up);
    }

    function build() {
      var next = mq.matches ? 'd' : 'm';
      if (next === mode) return;
      mode = next;
      anchor.innerHTML = ''; mount.innerHTML = '';
      document.querySelectorAll('.bmx-sheet, .bmx-tin').forEach(function (n) { n.remove(); });
      /* reset bloc 3 : retire la rangée ATC injectée et restaure la CTA mur d'origine */
      var assoc = document.getElementById('rv5-bloc-associated');
      if (assoc) {
        assoc.removeAttribute('data-atc-built');
        var injected = assoc.querySelector('.bmx-atc3row'); if (injected) injected.remove();
        var origCta = assoc.querySelector('.rv5-wall-cta'); if (origCta) origCta.style.display = '';
      }
      document.documentElement.classList.remove('bmx-detail-open', 'bmx-slides');
      document.documentElement.style.removeProperty('overflow');
      if (next === 'd') buildDesktop(); else buildMobile();
    }

    installDesktopMagneticScroll();
    build();

    /* « + d'infos » (repère « descendre », >749 uniquement) : visible en haut, s'efface au défilement. */
    (function setupScrollCue() {
      var link = document.querySelector('.rv5-more-link');
      if (!link) return;
      var mqMagnetic = window.matchMedia('(min-width: 900px)');
      function upd() { link.classList.toggle('is-hidden', window.scrollY > window.innerHeight * 0.5); }
      upd();
      window.addEventListener('scroll', upd, { passive: true });
      link.addEventListener('click', function (e) {
        if (mqMagnetic.matches) return; /* ≥900 : géré par buildDesktop (onglet Cartel + animation) */
        e.preventDefault();
        var mount = document.getElementById('bisou-mockup-mount');
        if (mount) mount.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    })();

    /* ── Pourquoi ce nom, et pas « t » ──
       « var t » vivait ici, dans la portee de init(). Le pont i18n ajoute plus
       tard a declare un helper t(cle, repli) au niveau du module. Par hoisting,
       tous les t(...) ecrits DANS init() — donc dans buildDesktop() et
       buildMobile() — ne visaient plus le helper mais ce chronometre, encore
       undefined : « t is not a function », buildDesktop() mourait a sa premiere
       ligne, et #bisou-mockup-mount restait vide. C'est le cartel disparu.
       Le chronometre porte desormais un nom a lui. Ne pas le rappeler « t ». */
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(build, 180); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.bmx-sheet.is-open, .bmx-tin.is-open').forEach(function (n) { n.classList.remove('is-open'); document.documentElement.style.removeProperty('overflow'); setTimeout(function () { n.setAttribute('hidden', ''); }, 220); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
